module.exports = __webpack_public_path__ + "static/media/rupee-sign.923eb4ce.svg";